/**
 * ClientAdminShell — Layout wrapper for the ClientAdmin console.
 * Renders the bridge health panel as a fixed left column
 * and the page content as a scrollable right column.
 */
import type { ReactNode } from "react";
import { ClientAdminBridgePanel } from "./ClientAdminBridgePanel";

interface ClientAdminShellProps {
    children: ReactNode;
}

export function ClientAdminShell({ children }: ClientAdminShellProps) {
    return (
        <div className="flex h-screen overflow-hidden bg-primary">
            <ClientAdminBridgePanel />
            <div className="flex flex-1 flex-col overflow-auto">{children}</div>
        </div>
    );
}
